import { makeStyles } from '@mui/styles';

export const pageNotFoundStyles = makeStyles(() => ({
  logo: {
    width: '100px',
    height: '100px',
    mb: '6px',
  },

  heading2: {
    fontSize: '20px !important',
    color: 'white',
    fontWeight: '700 !important',
    marginTop: '8px !important',
  },

  notFoundParent: {
    backgroundColor: '#fff',
    zIndex: 99999,
    height: '100vh',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },

  notfoundpagebox: {
    backgroundColor: 'white',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 30px',
    gap: '50px',
  },

  notFoundHeading: {
    fontSize: '45px !important',
    color: '#0F2853',
    fontWeight: '900 !important',
    textAlign: 'center',
  },
  notFoundSubHeading: {
    '&.MuiTypography-root': {
      fontSize: '25px !important',
      color: '#0F2853',
      fontWeight: '700 !important',
      textAlign: 'center',
    },
  },
  backHomeBtn: {
    fontWeight: '600 !important',
    color: '#fff !important',
    marginTop: '16px !important',
    backgroundColor: '#0F2853  !important',
    justifyContent: 'center',
  },

  imgBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    gap: '10px',
  },

  imgBoxText: {
    fontFamily: 'Mukta',
    fontSize: '21px',
    lineHeight: '27px',
    fontWeight: '700',
    color: '#2A3752',
    paddingRight: '5px',
  },
}));
